import { useSelector } from 'react-redux';
import { useRef, useState } from 'react';

import selectors from '../../store/selectors';

const tyniecId = '1353006595847266304';

const accountIdsToShowQuestionnaire = [
  '1395773119405883392', // Parafia św. Michała Archanioła Warszawa-Grodzisk
  // tyniecId, // Opactwo Benedyktynów w Tyńcu
  // '1232003310810333184', // Parafia św. Michała Archanioła Warszawa
  '1523340304298192896', // Klasztor Zakonu Braci Mniejszych Kapucynów w Krakowie
  // '654463132773478400', // Parafia Demo
  // '1516868980247126016', // Parafia Demonstracyjna
  '1461007000884875264', // Miłosierdzie Myślibórz
];

export const useInitFeathery = userEmail => {
  const accountId = useSelector(selectors.getAccountId);
  const shouldInit = useRef(true);
  const shouldShowQuestionnaire =
    accountIdsToShowQuestionnaire.includes(`${accountId}`) && userEmail;
  const featheryFormName =
    accountId === tyniecId
      ? 'Intencje online - (opactwo) ankieta cyklicznej e-tacy'
      : 'Intencje online - (parafia) ankieta cyklicznej e-tacy';
  const [initDone, setInitDone] = useState(false);

  if (shouldInit.current && shouldShowQuestionnaire) {
    import('@feathery/react').then(({ init }) => {
      // const testSdk = '18dfd6af-1ed7-4ec2-92ce-6450ee472a46';
      const prodSdk = '94003a4d-cf7b-4b69-a344-55da33e88f42';
      init(prodSdk, {
        preloadForms: [featheryFormName],
      }).then(() => {
        setInitDone(true);
      });
    });
    shouldInit.current = false;
  }

  return { initDone, featheryFormName, userEmail };
};
